import { ContainerIcons } from "./styles";
import icon1 from '../../../assets/Img/anima1.jpg';
import icon2 from '../../../assets/Img/anima2.jpg';
import icon3 from '../../../assets/Img/anima3.jpg';
import icon4 from '../../../assets/Img/anima4.jpg';

export function Icons() {
    return (
        <ContainerIcons>
            <div className="innerIconContainer">
                <div>
                    <img className="second-img" src={icon1} alt="Cosmic Skull" />
                    <p>Cosmic Skull</p>
                </div>
                <div>
                    <img src={icon2} alt="Space Sparrow" />
                    <p>Space Sparrow</p>
                </div>
            </div>
            <div className="innerIconContainer">
                <div>
                    <img src={icon3} alt="Pink Space Sparrow" />
                    <p>Pink Space Sparrow</p>
                </div>
                <div>
                    <img src={icon4} alt="Andromeda Body" />
                    <p>Andromeda Body</p>
                </div>
            </div>
        </ContainerIcons>
    )
}